import React from 'react';
import Form from './AddBook';
import Book from './Book';

function Books() {
  return (
    <>
      <Book />
      <Form />
    </>
  );
}

export default Books;
